type Props = {
  price: string;
};

export default function PriceIcon({ price }: Props) {
  return (
    <div className="font-bold tracking-tighter text-3xl">
      <span className="text-red-600/50">$</span>
      <span className="text-red-600">{price}</span>
    </div>
  );
}
